import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/authContext";

/**
 * A higher-order component that ensures the user is authenticated to access a route.
 * If the user is not authenticated, they are redirected to the login page.
 */
const RequireAuth = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default RequireAuth;
